import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";

export function ManualOverrideDialog({ open, setOpen, children, handleSend }) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="confirm-override-dialog-title"
      aria-describedby="confirm-override-dialog-description"
      fullWidth
      maxWidth={"md"}
      classes={{ paper: { minHeight: "80vh", maxHeight: "80vh" } }}
    >
      <DialogTitle id="shell-dialog-title">{"Override bevestigen"}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            handleSend();
          }}
        >
          Send
        </Button>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
